import axios from 'axios';
const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
export default axios;